import { Box, Stack } from '@mui/material'
import { ButtonUI } from 'ui/buttons/ButtonUI'
import Drawer from 'ui/Drawer'
import Preloader from 'ui/Preloader'
import ErrorDialog from '../../../utils/ErrorDialog'
import { useSettingUser } from '../hooks/useSettingUser'
import GeneralInfoBlock from './GeneralInfoBlock/GeneralInfoBlock'
import PasswordBlock from './PasswordBlock/PasswordBlock'
import RoleContactBlock from './RoleContactBlock/RoleContactBlock'

interface SettingUserProps {
	onClose: () => void
	open: boolean
	userId?: number
}

const SettingUser: React.FC<SettingUserProps> = ({ onClose, open, userId }) => {
	const {
		availableRoles,
		availableRolesPending,
		currentUserId,
		userData,
		newPassword,
		serverErrorText,
		isCreateRolePopup,
		openErrorPopup,
		downloadUserInfo,
		errorStateMessages,
		errorState,
		isDirty,
		setNewPassword,
		setServerErrorText,
		setIsCreateRolePopup,
		setOpenErrorPopup,
		setErrorStateMessages,
		setErrorState,
		updateUserDataField,
		saveDataAtServer,
		changeCurrentRole,
		returnAtEditCreateRoleForm,
		returnAtEditEditUserForm,
		confirmExitWithoutChanges,
		validators,
	} = useSettingUser({ onClose, open, userId })
	return (
		<Drawer
			open={open}
			onClose={onClose}
			title={
				currentUserId ? 'Редактирование пользователя' : 'Создание пользователя'
			}
			anchor='right'
		>
			<Stack direction='column' gap='16px' margin='0px 24px'>
				{availableRolesPending || downloadUserInfo ? (
					<Preloader />
				) : (
					<>
						<GeneralInfoBlock
							userData={userData}
							currentUserId={currentUserId}
							errorState={errorState}
							setErrorState={setErrorState}
							validators={validators}
							updateUserDataField={updateUserDataField}
						/>
						<RoleContactBlock
							availableRoles={availableRoles}
							currentUserId={currentUserId}
							userData={userData}
							errorState={errorState}
							setErrorState={setErrorState}
							validators={validators}
							updateUserDataField={updateUserDataField}
							isCreateRolePopup={isCreateRolePopup}
							setIsCreateRolePopup={setIsCreateRolePopup}
							changeCurrentRole={changeCurrentRole}
							setErrorStateMessages={setErrorStateMessages}
							setOpenErrorPopup={setOpenErrorPopup}
							serverErrorText={serverErrorText}
							setServerErrorText={setServerErrorText}
						/>
						<PasswordBlock
							newPassword={newPassword}
							setNewPassword={setNewPassword}
						/>
						<Box
							sx={{
								position: 'sticky',
								bottom: 0,
							}}
						>
							<ButtonUI
								sx={{ height: '56px', width: '100%', mb: '24px' }}
								onClick={saveDataAtServer}
								disabled={
									(currentUserId && !isDirty && !newPassword) ||
									(!currentUserId && !newPassword) ||
									userData.role === null ||
									userData.role === -1 ||
									!userData.fullname ||
									userData.fullname.trim().split(' ').length !== 2 ||
									!userData.email ||
									!userData.position ||
									(newPassword.length !== 0 &&
										newPassword.length < 8 &&
										/^[a-zа-я\d]*$/.test(newPassword) &&
										!/^[A-Za-z0-9!-@#$%.^,&*()_{}[\];:"/|^]+$/.test(
											newPassword,
										))
								}
							>
								{currentUserId ? 'Сохранить' : 'Создать'}
							</ButtonUI>
						</Box>
					</>
				)}

				<ErrorDialog
					openErrorPopup={openErrorPopup}
					title={errorStateMessages.payload?.title}
					description={errorStateMessages.payload?.description}
					changeCurrentRole={changeCurrentRole}
					returnAtEditCreateRoleForm={returnAtEditCreateRoleForm}
					type={errorStateMessages.type}
					returnAtEditEditUserForm={returnAtEditEditUserForm}
					confirmExitWithoutChanges={confirmExitWithoutChanges}
				/>
			</Stack>
		</Drawer>
	)
}

export default SettingUser
